<template mlns="http://www.w3.org/1999/html">
  <div v-loading="initLoading">
  <div style="padding: 20px;position:relative">
    <div style="font-size: 20px">
      <el-breadcrumb separator="/" style="margin-left: 10px; margin-top: 5px">
        <el-breadcrumb-item :to="{ path: '/console' }" >数据中心</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/ServiceChargeView' }" >服务费账单</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div style="font-size: 25px;margin-top: 10px;">
      <p>服务费账单</p>
    </div>
    <div style="display: flex;right: 20px;top: 22px;position: absolute">
      <template style="flex: 1">
      <div v-show="invoiceBank.jb_wallet&&suppliers[0].methodCount === 0" class="el-card box-card">
        <div class="el-card__header cus-header">
          <slot name="header">充值及服务费打款至以下账户</slot>
        </div>
        <div class="el-card__body" style="padding: 0px 10px">
          <div class="text">
            <span>公司名称：上海橙籽维管信息技术有限公司<br/>开户银行：建设银行上海大连路支行<br/>银行账户：31050175410000000956</span>
          </div>
        </div>
      </div>
    </template>
      <template style="flex: 1">
        <div v-show="rule" class="el-card box-card">
          <div class="el-card__header cus-header">
            <slot name="header">收费规则</slot>
          </div>
          <div class="el-card__body" style="padding: 0px 10px">
            <div class="text">
              <sapn>收费规则：{{rule}}</sapn>
            </div>
          </div>
        </div>
      </template>
    </div>
      <div style="width: 100%; font-family: 微软雅黑; font-size: 25px">
        <el-row>
          <el-col :span="8">
            <el-form :model="ruleForm" status-icon label-width="100px" style="margin-top: 10px;width: 300px" >
              <el-form-item label="计费月份" style="width: 700px">
                <el-date-picker
                  v-model="ruleForm.startDate"
                  type="month"
                  format="yyyy-MM"
                  value-format="yyyy-MM"
                  placeholder="开始日期"
                  :picker-options="pickerOptions0">
                </el-date-picker>
                <el-date-picker
                  v-model="ruleForm.endDate"
                  type="month"
                  format="yyyy-MM"
                  value-format="yyyy-MM"
                  placeholder="结束日期"
                  :picker-options="pickerOptions1">
                </el-date-picker>
              </el-form-item>
              <el-form-item label="供应商">
                <el-select popper-class="el-select" v-model="supplier" multiple value-key="id" placeholder="必选"  style="width: 400px">
                  <select-all-option v-model="supplier" :data="suppliers" :autoSelect="true"/>
                  <el-option
                    v-for="item in suppliers"
                    :key="item.id"
                    :label="item.name"
                    :value='item'>
                  </el-option>
                </el-select>
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
        <!--<div style="margin-left: 10vw">
          <el-button style="color: white; letiant:'outlined';border-color: #FF6633; background-color: #FF6633;margin-bottom: 10px"   :loading="loading" @click="Channel">确定</el-button>
          <el-button style="color: white; letiant:'outlined';border-color: #FF6633; background-color: #FF6633;margin-bottom: 10px"   :disabled="tableData.length==0" @click="exportExcel">导出excel</el-button>
        </div>
        <div style="margin-left: 80%;margin-right:2%;margin-top:-50px;color: #8c939d">
          <span style="font-size: 15px">
            费用通常会在创建后的４８小时内自动确认，
            若有疑问请及时与平台沟通。
            您也可以点击［确认费用］，提前完成费用确认。
          </span>
        </div>-->
        <el-row :gutter="20" style="margin-bottom: -17px">
          <el-col :span="8"><div class="grid-content bg-purple" style="margin-left: 10vw">
            <el-button style="color: white; letiant:'outlined';border-color: #FF6633; background-color: #FF6633;margin-bottom: 10px"   :loading="loading" @click="Channel">确定</el-button>
            <el-button style="color: white; letiant:'outlined';border-color: #FF6633; background-color: #FF6633;margin-bottom: 10px"   :disabled="tableData.length==0" @click="exportExcel">导出excel</el-button>
          </div></el-col>
          <el-col :span="16" style="padding-left: 14%;margin-top: 4px">
            <div class="grid-content bg-purple" style="line-height: 1.25em;text-align: right;font-size: 10px;padding:0;font-family: 微软雅黑;font-weight: 0;color: #909399">
            <div>
                若您对新出具费用有疑问的可反馈提交问题，若您在48小时内无反馈操作，系统将自动完成确认。
            </div><br>
            <div>
                 通过帐扣支付服务费的客户，系统将在费用确认后的下一个周二扣除服务费，届时请确保账户余额充足。
            </div>
          </div>
          </el-col>
        </el-row>
      </div>
    <div style="position: relative">
      <el-table
      :data="tableData"
      id = "tableData"
      style="margin-top: 20px"
      :max-height="600"
      border>
        <el-table-column
          prop="supplierName"
          width="200"
          align="center"
          label="供应商名称">
        </el-table-column>
        <el-table-column
        prop="month"
        width="100px"
        align="center"
        label="计费月份">
        </el-table-column>
        <el-table-column
          prop="amount"
          align="center"
          width="120px"
          label="费用金额">
        </el-table-column>
        <el-table-column
          align="center"
          prop="description"
          width="200px"
          show-overflow-tooltip
          label="费用说明">
          <template slot-scope="scope">
            <span style="white-space:pre-line;">{{scope.row.description}}</span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="invoiceCode"
          width="200px"
          label="发票编码">
        </el-table-column>
        <el-table-column
          align="center"
          prop="receiveds"
          min-width="450px"
          label="处理进度">
          <template slot-scope="scope">
              <el-steps :active="scope.row.active" :process-status="scope.row.blue_box" align-center>
              <el-step :title="scope.row.pro_arr[0].pro_name" :description="scope.row.pro_arr[0].date" @click.native="open(scope.row,0)"></el-step>
              <el-step :title="scope.row.pro_arr[1].pro_name" :description="scope.row.pro_arr[1].date" @click.native="open(scope.row,1)"></el-step>
              <el-step :title="scope.row.pro_arr[2].pro_name" :description="scope.row.pro_arr[2].date" @click.native="open(scope.row,2)"></el-step>
              <el-step :title="scope.row.pro_arr[3].pro_name" :description="scope.row.pro_arr[3].date" @click.native="open(scope.row,3)"></el-step>
            </el-steps>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div tabindex="-1" v-show="dialog" role="dialog" aria-atomic="true" aria-modal="true" class="el-message-box__wrapper" style="z-index: 2006">
      <div class="el-message-box el-message-box--center" style="padding-bottom: 0px;font-family: 微软雅黑;background-color: rgb(255,255,255);
      font-size: 15px;width: 270px;border-radius:8px;color: #606266;">
        <div style="width: 100%">
          <div class="el-message-box__header" style="padding-top: 10px;text-align: center;">
            <span>费用情况确认</span>
          </div>
          <div class="el-message-box--center" style="padding-bottom: 0px;padding-top: 3px">
            <div style="width: 100%">
              <div style="float: left;padding-left: 15px;width: 80%">确认费用无误</div>
              <div style="float: left;margin-left: 7px">
                <el-radio v-model="radio" :label="0"><span v-show="false">0</span></el-radio>
              </div>
            </div><br/>
            <div style="width: 100%;height: 12px"></div>
            <div style="width: 100%">
              <div style="float: left;padding-left: 15px;width: 80%">对费用有疑义，需要反馈</div>
              <div style="float: left;margin-left: 7px">
                <el-radio v-model="radio" :label="1"><span v-show="false">1</span></el-radio>
              </div>
            </div>
            <div style="width: 100%">
              <el-input v-model="feedback" type="text" style="margin-top: 15px;width: 90%;margin-left: 5%;padding-bottom: 15px"
                        clearable size="small" :disabled="radio == 0 || radio == -1"></el-input>
            </div>
          </div>
        </div>
        <button type="button" class="el-button el-button--default" style="width: 50%;border-radius: 0px;border-left: 0;
        border-bottom: 0px" @click="close">
          <span>取消</span>
        </button>
        <button type="button" class="el-button el-button--default" style="width: 50%;margin-left: 0;border-radius: 0px;
        border-right: 0px;border-bottom: 0px" @click="created">
          <span>确认</span>
        </button>
      </div>
    </div>
    <div v-if="dialog" class="v-modal" tabindex="0" style="z-index: 2005;background-color: rgb(122,122,122)"></div>
  </div>
  </div>
</template>

<script>
import {getFinanceSupplierByUserId} from "@/api/ServiceCharge"
import {selectServiceCharge, updateConfirmAt} from "@/api/ServiceCharge"
import XLSX from "xlsx"
import FileSaver from "file-saver"
import selectAllOption from "@/components/selectAllOption";

export default {
  name: "ServiceChargeView",
  components: {selectAllOption},
  data(){
    return{
      pickerOptions0: {
        disabledDate: (time) => {
          if(this.stringToDate('2020-08').getTime() > time.getTime())
            return true
          if (this.ruleForm.endDate) {
            return time.getTime() > new Date(this.ruleForm.endDate).getTime()
          } else {
            return time.getTime() > Date.now()
          }
        }
      },
      pickerOptions1: {
        disabledDate: (time) => {
          if(this.stringToDate('2020-08').getTime() > time.getTime())
            return true
          if (this.ruleForm.startDate) {
            return (time.getTime() < new Date(this.ruleForm.startDate).getTime() || time.getTime() > Date.now())
          } else {
            return time.getTime() > Date.now()
          }
        }
      },
      suppliers: [],
      supplierName: '',
      loading: false,
      tableData: [],
      supplier: [],
      ruleForm : {
        startDate: this.getNowTime(-3),
        endDate: this.getNowTime(0),
        supplierId: [],
        supplierName: ''
      },
      token: "",
      dialog: false,
      radio: -1,
      feedback: '',
      serviceId: '',
      month:'',
      rule: '',   // 右上角收费规则
      invoiceBank: {},   // 收款账户
      initLoading:true
    }
  },
  mounted() {
    this.token = localStorage.getItem('token')
    getFinanceSupplierByUserId(this.token).then(res => {
      if (res.data != null) {
        this.suppliers = res.data
      }
      this.initLoading = false
    }).catch(error => {
      let status = error.response.status;
      if (status == 500){
        this.$notify.error({
          title: '错误',
          message: '查询失败，请联系管理员',
          position: 'bottom-right'
        })
      }
    })
  },
  methods: {
    open(row,index){
      if (row.pro_arr[index].pro_name === "确认时间") {
        if (row.confirmAt == null || row.confirmAt === ""){
          this.dialog = true
          this.serviceId = row.serviceId;
          this.month = row.month;
        }
      }
    },
    close(){
      this.radio = -1
      this.dialog = false
      this.feedback = ''
    },
    created(){
      if (this.radio == -1){
        this.$message.warning("请选择确认或反馈")
        return ;
      }
      if (this.radio == 1){
        if (this.feedback.length < 1){
          this.$message.warning("未输入反馈信息")
          return ;
        }

        else if (this.feedback.length > 100){
          this.$message.warning("反馈字数不能超过100字")
          return ;
        }
      }

      var param = {
        id:this.serviceId,
        feedback:this.feedback,
        radio: this.radio,
        month: this.month
      }

      updateConfirmAt(this.token,param).then(res => {
        let {data} = res
        if (data.code == 200){
          this.$message.success("费用确认成功")
          this.close()
          this.Channel()
        }else {
          this.$message.error(data.msg)
        }
      }).catch(error => {
        let status = error.response.status
        if (status == 500){
          this.$notify.error({
            title: '错误',
            message: '查询失败，请联系管理员',
            position: 'bottom-right'
          })
        }
      })
    },
    getNowTime (i) {
      let now = new Date()
      let year = now.getFullYear() // 得到年份
      let month = now.getMonth() // 得到月份
      if (month + 1+i <= 0){
        month = 12 + (month + 1+i)
        year += -1
      }else
        month = month + 1+i
      month = month.toString().padStart(2, '0')
      let defaultDate = `${year}-${month}`
      return defaultDate
    },
    stringToDate(str){
       let tempStrs = str.split(" ")
       let dateStrs = tempStrs[0].split("-")
       let year = parseInt(dateStrs[0], 10)
       let month = parseInt(dateStrs[1], 10) - 1
       let date = new Date(year, month)
       return date;
    },
    exportExcel(){
      let  name = this.supplierName + "服务费通知"
      let  worBook =XLSX.utils.book_new()
      let table =  document.querySelector("#tableData")
      let workSheet = XLSX.utils.table_to_sheet(table)
      workSheet['F1'] = {t: "s", v: "创建时间"}
      workSheet['G1'] = {t: "s", v: "确认时间"}
      workSheet['H1'] = {t: "s", v: "开票时间"}
      workSheet['I1'] = {t: "s", v: "付款时间"}
      workSheet["!fullref"] ="A1:I"+this.tableData.length+1
      workSheet["!ref"] ="A1:I"+this.tableData.length+1
      let s = this.tableData.length
      for(let i = 2;i< s+2;i++){
        if(workSheet['F'+i].v){
          let value = workSheet['F'+i].v
          let crAt_index = value.indexOf("创建时间") + 4
          let createdAt = value.substring(crAt_index, crAt_index+19)
          if (createdAt) {
            workSheet['F'+i] = {t: "s", v: createdAt}
          }
          let cfAt_index = value.indexOf("确认时间") + 4
          let confirmAt = value.substring(cfAt_index, cfAt_index+19)
          // 无确认时间时
          if (value.substring(cfAt_index,cfAt_index+7) === "点此确认/反馈") {
            confirmAt = "等待确认"
          }
          if (confirmAt) {
            workSheet['G'+i] = {t: "s", v: confirmAt}
          }
          let reAt_index = value.indexOf("开票时间") + 4
          let receivedTime = value.substring(reAt_index, reAt_index+19)
          // 无开票时间时
          if (value.substring(reAt_index,reAt_index+4) === "等待开票") {
            receivedTime = "等待开票"
          }
          if (receivedTime) {
            workSheet['H'+i] = {t: "s", v: receivedTime}
          }
          let paAt_index = value.indexOf("付款时间") + 4
          let paymentTime = value.substring(paAt_index, paAt_index+19)
          // 无付款时间时
          if (value.substring(paAt_index,paAt_index+4) === "等待付款") {
            paymentTime = "等待付款"
          }
          if (paymentTime) {
            workSheet['I'+i] = {t: "s", v: paymentTime}
          }
        }
      }
      workSheet["!cols"] = [{width:20},{width:20},{width:20},{width:20},{width:30},{width:20},{width:20},{width:20},{width:20},{width:20}];
      XLSX.utils.book_append_sheet(worBook,workSheet,"服务费")
      let wbout = XLSX.write(worBook, {
        bookType: "xlsx",
        bookSST: true,
        type: "array"
      })
      let tmpDown = new Blob([wbout], {
        type: "application/octet-stream"
      });
      FileSaver.saveAs(tmpDown, name +"_"+this.ruleForm.startDate+"-"+this.ruleForm.endDate+ ".xlsx")
      return wbout
    },
    Channel(){
      let token = localStorage.getItem('token')
      this.loading = true
      this.ruleForm.supplierId = this.supplier.map(s => s.id)
      this.ruleForm.supplierName = this.supplier.name
      selectServiceCharge(token,this.ruleForm).then(res => {
        let data = res.data
        if(data.code == 200){
          this.tableData = data.date.collect
          this.supplierName = this.tableData[0].supplierName
          this.invoiceBank = data.date.invoiceBank
          this.rule = this.tableData[0].rule
          this.tableData.forEach((item,index) => {
            // 构建处理进度
            let pro_arr = []
            pro_arr[0] = {"pro_name": "创建时间","date": item.createdAt}
            pro_arr[1] = {"pro_name": "确认时间","date": item.confirmAt?item.confirmAt:"点此确认/反馈"}
            pro_arr[2] = {"pro_name": "开票时间","date": item.receivedTime&&item.receivedTime!=="未开"?item.receivedTime:"等待开票"}
            pro_arr[3] = {"pro_name": "付款时间","date": item.paymentTime?item.paymentTime:"等待付款"}
            // 当前步骤状态为点此确认时设置样式为蓝色
            let blue_box = pro_arr[1].date === "点此确认/反馈" ? "process" : "wait"
            // 排序(并且date为空排到最后)
            pro_arr.sort((a,b)=>{
              if (a.date === b.date) {
                return 0;
              }else {
                // 降序
                if (a.date !== "点此确认/反馈" && a.date !== "等待开票" && a.date !== "等待付款") {
                  return a.date.localeCompare(b.date)
                }
              }
            })
            // 步骤条的index
            let active = 4
            for (let i = 0; i < pro_arr.length; i++) {
              if (pro_arr[i].date == null || pro_arr[i].date === "点此确认/反馈" || pro_arr[i].date === "等待开票" || pro_arr[i].date === "等待付款") {
                active = i;
                break;
              }
            }
            this.tableData[index].pro_arr = pro_arr
            this.tableData[index].active = active
            this.tableData[index].blue_box = blue_box
          })
          if (this.ruleForm.supplierId.length > 1)
            this.supplierName+="等"
          this.$message.success(data.msg)
        }else{
          this.$notify.error({
            title: '错误',
            message: data.msg,
            position: 'bottom-right'
          })
          this.tableData = []
        }
      }).catch(error => {
        let status = error.response.status;
        if (status == 500){
          this.$notify.error({
            title: '错误',
            message: '查询失败，请联系管理员',
            position: 'bottom-right'
          })
        }
      }).finally(() => {
        this.loading = false
      })
    },
    invoicePathFormatter(row){
      if (row.invoiceType == '电子普票'){
        if (row.invoicePath)
          return "<a target='_blank' href='"+row.invoicePath+"'>发票链接</a>" +
            "<span style='display: none'>"+row.invoicePath+"</span>"
        else
          return '<span>电子发票未开具</span>'
      }
      if (row.invoiceType == '纸质增票'){
        if (row.received == '已开票')
          return '<span>纸质发票已开具</span>'
        else
          return '<span>纸质发票未开具</span>'
      }
    }
  },
  filters : {
    'amountFilter': function (val){
      return val.replace("#","")
    }
  }
}
</script>

<style scoped>
body .el-table:before {
  z-index: inherit;
}
.el-select .el-select-dropdown__list {
  list-style: none;
  padding: 0px 0;
  margin: 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.text {
  font-size: 14px;
  white-space: pre-line;
  text-align: left;
  line-height: 25px;
}
.box-card {
  z-index: 3 !important;
  height: 100%;
  margin: 10px;
  box-shadow:1px 1px 10px #cccccc;
}
.cus-header {
  padding: 10px 10px;
  background-color: #ef6c00;
  color: white;
}
/deep/ .el-step__head.is-process {
  color: #C0C4CC;
  border-color: #C0C4CC;
}
/deep/ .el-step__title.is-process {
  font-weight: 500;
  color: #C0C4CC;
}
/deep/ .el-step__description.is-process {
  color: #409eff;
}
</style>
